import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import DocumentTitle from "react-document-title-sz";
import "../../../index.css";
import { BoardTitle } from "../../../components/board/board";
import { AssetWrapper } from "../../../components/asset/asset-wrapper";
const FloatMenu = React.lazy(() =>
  import("../../../components/menu/floatMenu")
);
const ErrorMonitoring = React.lazy(() => import("./ErrorMonitoringScreen"));
export default function ProviderErrorList() {
  const dispatch = useDispatch();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let token = params.get("access_token");
    if (token) {
      dispatch({ type: "SET_AUTH_TOKEN", token: token });
    }
  }, [dispatch]);

  return (
    <DocumentTitle title="Exirio | Admin Portal">
      <AssetWrapper>
        <BoardTitle title="Provider Error List" />
        <ErrorMonitoring />
        <FloatMenu />
      </AssetWrapper>
    </DocumentTitle>
  );
}
